export default __webpack_public_path__ + "static/media/data_image.2387e411.jpeg";